export const RECORDING_UPDATED_EVENT = 'recording_updated';
export const RECORDING_REMOVED_EVENT = 'recording_removed';
export const RECORDING_ADDED_EVENT = 'recording_added';

export const getLiveUpdatesChannel = eventId =>
  `private-recording-library-event-${eventId}`;
